export const storageReducer = (state, action) => {
    switch(action.type) {
        default:
            return {...state};
    }
}